import { YesObject } from '@yes.technology/react-toolkit'
import fetchFilteraction from 'modules/filteraction/fetchFilteraction'
import api from 'utils/api'
import { Activity, FlatActivityModel } from 'types/shared'

export const DEFAULT_VALUE_PAGINATION_LIMIT = 10

export type ResolverContext = {
  filteractionUuid: string
}

export type DefaultValueResolver = (
  activityModel: FlatActivityModel,
  context: ResolverContext
) => Promise<Activity | null>

export async function fetchDefaultObjects(
  filteractionUuid: string
): Promise<YesObject[]> {
  const filteraction = await fetchFilteraction(filteractionUuid, false, false)
  if (!filteraction) return []

  const objectclassUuid = (
    filteraction.filter_action_objectclass as YesObject[]
  )?.[0]?.uuid

  if (!objectclassUuid) return []

  const result = await api.postObjectsFilter(
    {
      query: JSON.parse(filteraction.query),
      objectclass: objectclassUuid,
      orderby: [],
      pagination: { offset: 0, limit: DEFAULT_VALUE_PAGINATION_LIMIT },
      visualization: 'classic-list',
      skip_relations: true,
      skip_metadata: true,
      project_fields: { uuid: 1, des: 1 }
    },
    false,
    false
  )

  return result.objects ?? []
}
